export const renderText = (
  updated: boolean | undefined,
  updatedText: string | undefined,
  error: boolean | undefined,
  children: React.ReactNode
): string | true | React.ReactChild | React.ReactFragment | React.ReactPortal => {
  if (updated) {
    return updatedText || 'Sauvegardé'
  }
  if (error) {
    return 'Oups...'
  }
  if (children) {
    return children
  }
  return 'Enregistrer'
}
